import Backdrop from "./components/Backdrop";
import Critter from "./components/Critter";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Work from "./components/Work";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import useTheme from "./hooks/useTheme";

function App() {
  const { theme, toggleTheme } = useTheme();

  return (
    <>
      <Backdrop theme={theme} />
      <Header theme={theme} onToggleTheme={toggleTheme} />
      <main>
        <Hero theme={theme} onToggleTheme={toggleTheme} />
        <Work />
        <Skills />
        <Experience />
        <About />
        <Contact />
      </main>
      <Footer />
      <Critter theme={theme} />
    </>
  );
}

export default App;
